import React from 'react';
import FlatInstallationView from './FlatInstallationView';
import { I_Installation } from '../../../interfaces/InstallationTypes';
import { Route, Routes } from 'react-router-dom';
import routes from '../../../Resources/routes.json';
import SalidomoInstallation from './Installation';

interface installationSearchProps {
  installations: I_Installation[];
}

function InstallationSearch(props: installationSearchProps) {
  return (
    <>
      <FlatInstallationView installations={props.installations} />
      <Routes>
        {props.installations.map((installation) => {
          return (
            <Route
              key={installation.id}
              path={routes.installation + installation.id + '/*'}
              element={
                <SalidomoInstallation
                  key={installation.id}
                  current_installation={installation}
                  type="installation"
                ></SalidomoInstallation>
              }
            />
          );
        })}
      </Routes>
    </>
  );
}

export default InstallationSearch;
